export const IS_AUTHORIZED = "IS_AUTHORIZED";
export const VERSION = "VERSION";
export const IS_TOKEN_EXPIRED = "IS_TOKEN_EXPIRED";
export const GENERATE_STATE_AND_NONCE = "GENERATE_STATE_AND_NONCE";
export const RECEIVE_ACCESS_TOKEN = "RECEIVE_ACCESS_TOKEN";
export const RECEIVE_ID_TOKEN = "RECEIVE_ID_TOKEN";
export const RECEIVE_PROFILE_DATA = "RECEIVE_PROFILE_DATA";
export const CLEAR_ALL = "CLEAR_ALL";
export const CLEAR_STATE = "CLEAR_STATE";
export const LOADER = "LOADER";
export const MODAL_LOADER = "MODAL_LOADER";
export const ERROR = "ERROR";
export const SUCCESS = "SUCCESS";

export const GET_CUSTOMER_STATUS_FAULT = "GET_CUSTOMER_STATUS_FAULT";
export const GET_CUSTOMER_STATUS_FAULT_SUCCESS =
  "GET_CUSTOMER_STATUS_FAULT_SUCCESS";
export const GET_CUSTOMER_STATUS_FAULT_FAILED =
  "GET_CUSTOMER_STATUS_FAULT_FAILED";

export const GET_CUSTOMER_FAULT_IMAGE = "GET_CUSTOMER_FAULT_IMAGE";
export const GET_CUSTOMER_FAULT_IMAGE_SUCCESS =
  "GET_CUSTOMER_FAULT_IMAGE_SUCCESS";
export const GET_CUSTOMER_FAULT_IMAGE_FAILED =
  "GET_CUSTOMER_FAULT_IMAGE_FAILED";

export const EXPORT_FILE_REQUESTED = "EXPORT_FILE_REQUESTED";
export const EXPORT_FILE_SUCCESS = "EXPORT_FILE_SUCCESS";
export const EXPORT_FILE_FAILED = "EXPORT_FILE_FAILED";

export const EDIT_CUSTOMER_STATION_FAILT = "EDIT_CUSTOMER_STATION_FAILT";
export const EDIT_CUSTOMER_STATION_FAILT_SUCCESS =
  "EDIT_CUSTOMER_STATION_FAILT_SUCCESS";
export const EDIT_CUSTOMER_STATION_FAILT_FAILED =
  "EDIT_CUSTOMER_STATION_FAILT_FAILED";

export const DETAIL_UPDATE_SUCCESS = "DETAIL_UPDATE_SUCCESS";
export const DETAIL_UPDATE_ERROR = "DETAIL_UPDATE_ERROR";

export const GET_CUSTOMER_SUGGESTION = "GET_CUSTOMER_SUGGESTION";
export const GET_CUSTOMER_SUGGESTION_SUCCESS =
  "GET_CUSTOMER_SUGGESTION_SUCCESS";
export const GET_CUSTOMER_SUGGESTION_FAILED = "GET_CUSTOMER_SUGGESTION_FAILED";

export const GET_TRAIN_FAULTS = "GET_TRAIN_FAULTS";
export const GET_TRAIN_FAULTS_SUCCESS = "GET_TRAIN_FAULTS_SUCCESS";
export const GET_TRAIN_FAULTS_FAILED = "GET_TRAIN_FAULTS_FAILED";

export const GET_FAULT_HISTORY = "GET_FAULT_HISTORY";
export const GET_FAULT_HISTORY_SUCCESS = "GET_FAULT_HISTORY_SUCCESS";
export const GET_FAULT_HISTORY_FAILED = "GET_FAULT_HISTORY_FAILED";

export const SAVE_FEEDBACK = 'SAVE_FEEDBACK';
export const SAVE_FEEDBACK_SUCCESS = 'SAVE_FEEDBACK_SUCCESS';
export const SAVE_FEEDBACK_FAILED = 'SAVE_FEEDBACK_FAILED';

export const GET_ALL_REPORTS = 'GET_ALL_REPORTS';
export const GET_ALL_REPORTS_SUCCESS = 'GET_ALL_REPORTS_SUCCESS';
export const GET_ALL_REPORTS_FAILED = 'GET_ALL_REPORTS_FAILED';

export const GET_CONDITION_OPTIONS = 'GET_CONDITION_OPTIONS';
export const GET_CONDITION_OPTIONS_SUCCESS = 'GET_CONDITION_OPTIONS_SUCCESS';
export const GET_CONDITION_OPTIONS_FAILED = 'GET_CONDITION_OPTIONS_FAILED';

export const ADD_REPORT = 'ADD_REPORT';
export const ADD_REPORT_SUCCESS = 'ADD_REPORT_SUCCESS';
export const ADD_REPORT_FAILED = 'ADD_REPORT_FAILED';
export const CLEAR_REPORT = 'CLEAR_REPORT';


export const GET_REPORT_BY_ID = 'GET_REPORT_BY_ID';
export const GET_REPORT_BY_ID_SUCCESS = 'GET_REPORT_BY_ID_SUCCESS';
export const GET_REPORT_BY_ID_FAILED = 'GET_REPORT_BY_ID_FAILED';

export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAILED = 'GET_ALL_USERS_FAILED';


// export const EDIT_REPORT = 'EDIT_REPORT';
// export const EDIT_REPORT_SUCCESS = 'EDIT_REPORT_SUCCESS';
// export const EDIT_REPORT_FAILED = 'EDIT_REPORT_FAILED';


export const SAVE_STATION_LIST = "SAVE_STATION_LIST";
export const TOKEN_EXPIRED = "TOKEN_EXPIRED";



